import i18n from '~/i18n';

export const NUM_OF_TABLES = 45;

export const tableOptions = Array.from(Array(NUM_OF_TABLES).keys()).map(
  (_, index) => ({
    label: i18n.t('order_info_table_no', { no: index + 1 }),
    value: index + 1,
  })
);
